import { useState, useEffect } from 'react';
import styles from './RoboKidsPage.module.css';

export default function RoboKidsPage2() {
  const [guardianName, setGuardianName] = useState('');
  const [email, setEmail] = useState('');
  const [address1, setAddress1] = useState('');
  const [address2, setAddress2] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [zip, setZip] = useState('');
  const [childName, setChildName] = useState('');
  const [childAge, setChildAge] = useState('');
  const [startDate, setStartDate] = useState('');
  const [slideshowIndex, setSlideshowIndex] = useState(0);
  const [secondSlideshowIndex, setSecondSlideshowIndex] = useState(0);
  const [submitting, setSubmitting] = useState(false);

  const availableDates = ['2026-02-10', '2026-02-11', '2026-02-12', '2026-02-13'];

  const placeholderImages = [
    '/images/robokids-intermediate/placeholder3.png',
    '/images/robokids-intermediate/placeholder4.png',
    '/images/robokids-intermediate/robokids2.png',
  ];

  const secondSlideshowImages = [
    '/images/robokids-intermediate/secondshow3.png',
    '/images/robokids-intermediate/secondshow4.png',
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setSlideshowIndex((prev) => (prev + 1) % placeholderImages.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setSecondSlideshowIndex((prev) => (prev + 1) % secondSlideshowImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const handleRegister = async (e) => {
  e.preventDefault();
  setSubmitting(true);

  const formData = {
    guardianName,
    childName,
    childAge,
    email,
    addressLine1: address1,
    addressLine2: address2,
    city,
    state,
    zipCode: zip,
    startDate,
    classType: 'intermediate',
  };

  try {
    const response = await fetch(
      'https://vgiqj6ha4n5pewmu4zkwhsac740nucsz.lambda-url.us-east-1.on.aws/',
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      }
    );

    const data = await response.json();

    if (response.ok && data.checkoutUrl) {
      // ✅ Store in sessionStorage (DON’T append to Stripe URL!)
      sessionStorage.setItem('roboKidsWaiverSession', JSON.stringify(formData));
      window.location.href = data.checkoutUrl;
    } else {
      alert(data.message || 'Registration failed. Please try again.');
    }
  } catch (error) {
    console.error('Error submitting registration:', error);
    alert('Something went wrong. Please try again.');
  } finally {
    setSubmitting(false);
  }
};







  return (
    <div className={styles.roboKidsWrapper}>
      {/* Left column: registration form */}
      <div className={styles.leftColumn}>
        <h2>Register for Robo Kids Intermediate level Class!</h2>
        <form className={styles.form} onSubmit={handleRegister}>
          <label>Guardian Name:</label>
          <input type="text" required value={guardianName} onChange={(e) => setGuardianName(e.target.value)} />
          <label>Email:</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
          <label>Address Line 1:</label>
          <input type="text" required value={address1} onChange={(e) => setAddress1(e.target.value)} />
          <label>Address Line 2 (optional):</label>
          <input type="text" value={address2} onChange={(e) => setAddress2(e.target.value)} />
          <label>City:</label>
          <input type="text" required value={city} onChange={(e) => setCity(e.target.value)} />
          <label>State:</label>
          <input type="text" required value={state} onChange={(e) => setState(e.target.value)} />
          <label>ZIP Code:</label>
          <input type="text" required pattern="\d{5}" value={zip} onChange={(e) => setZip(e.target.value)} />
          <label>Child’s First Name:</label>
          <input type="text" required value={childName} onChange={(e) => setChildName(e.target.value)} />
          <label>Child’s Age:</label>
          <input type="number" required min="5" value={childAge} onChange={(e) => setChildAge(e.target.value)} />
          <label>Choose Class Start Date:</label>
          <select required value={startDate} onChange={(e) => setStartDate(e.target.value)}>
            <option value="">Select a date</option>
            {availableDates.map(date => (
              <option key={date} value={date}>
                {new Date(date + "T00:00:00").toLocaleDateString(undefined, {
                  month: 'long',
                  day: 'numeric',
                  year: 'numeric'
                })}
              </option>
            ))}
          </select>

          <button type="submit" disabled={submitting} className={styles.registerButton}>
            {submitting ? "Processing..." : "Proceed to Payment"}
          </button>
        </form>
      </div>

      {/* Middle column: slideshows */}
      <div className={styles.slideshowColumn}>
        <div className={styles.slideshowContainer}>
          <img
            src={placeholderImages[slideshowIndex]}
            alt={`Slideshow image ${slideshowIndex + 1}`}
            className={styles.slideshowImage}
          />
          <p>Enroll your child today!</p>
        </div>
        <div className={styles.slideshowContainer}>
          <img
            src={secondSlideshowImages[secondSlideshowIndex]}
            alt={`Second slideshow image ${secondSlideshowIndex + 1}`}
            className={styles.slideshowImage}
          />
          <p style={{ fontSize: '0.75rem', color: '#777' }}>
            Actual kit contents may vary in types, essential components will be the same.
          </p>
        </div>
      </div>


{/* Right column: About + FAQ */}
<div className={styles.rightColumn}>
  <h2>Intermediate AI Robotics & Coding – $500</h2>
  <p>
    This course is for students ready to take robotics to the next level. Building on
    foundations, kids will integrate <strong>sensors, motors, and AI logic</strong> to
    create smart robots that react to their environment in real time.
  </p>
  <ul>
    <li><strong>What's Included:</strong>
      <ul>
        <li>AI-ready electronics pack: LEDs, resistors, jumper wires, and breadboard</li>
        <li>DC motors, servo modules, motor driver circuits, and Arduino-compatible controller</li>
        <li>Sensor kit: motion, light, and touch sensors for interactive builds</li>
        <li>Robot chassis, wheels, brackets, and hardware for advanced projects</li>
        <li>Tools kit: precision screwdriver, wire strippers, fasteners, and adhesives</li>
        <li>Step-by-step digital project guide with AI coding examples</li>
      </ul>
    </li>
    <li><strong>6-Week Program (1 session/week):</strong> Live video call sessions with guided builds and interactive Q&A.</li>
    <li><strong>What Kids Will Learn:</strong>
      <ul>
        <li>Programming robots with condition-based responses</li>
        <li>Using sensors to trigger movement, light, and sound</li>
        <li>AI logic basics: if-then rules and decision making</li>
        <li>Building powered robots with integrated intelligence</li>
      </ul>
    </li>
    <li><strong>Recommended Age:</strong> 8–14 years. Prior experience helps, but not required.</li>
  </ul>

  {/* FAQ Section */}
  <div className={styles.faqBox}>
    <h3>❓ Frequently Asked Questions</h3>
    <details><summary><strong>What age is this class for?</strong></summary><p>Ages 8–14. Beginners may prefer our Basic course first.</p></details>
    <details><summary><strong>Do kids need experience?</strong></summary><p>Some prior exposure to electronics helps, but isn’t required. Step-by-step guidance is provided.</p></details>
    <details><summary><strong>Do we need extra tools?</strong></summary><p>No — everything needed is shipped in the kit. Just have a device ready for the video call.</p></details>
    <details><summary><strong>Will the robots move?</strong></summary><p>Yes! Students will create functional moving robots with sensors and motors.</p></details>
    <details><summary><strong>Are the sessions recorded?</strong></summary><p>Yes, recordings are available on request.</p></details>
    <details><summary><strong>How long is each class?</strong></summary><p>60–75 minutes with live help and project support.</p></details>
    <details><summary><strong>Can siblings build together?</strong></summary><p>Yes, but we recommend one kit per child for the best experience.</p></details>
    <details><summary><strong>What’s unique about Intermediate level?</strong></summary><p>Kids move from basic circuits into AI-driven builds using sensors and logic.</p></details>
  </div>
</div>


    </div>
  );
}
